export const activeSideNav = "border-r-2 border-blue-600  bg-blue-100/70 text-blue-500 border-b-transparent";

export const buttonBaseClasses = " px-6 py-2 text-sm font-medium rounded";
